<template>
  <div class="contact-us">
    <div id="wufoo-z1a5agy50rom721">
      Fill out my
      <a href="https://berriesandblooms.wufoo.com/forms/z1a5agy50rom721">
        online form
      </a>.
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsForm',
  data () {
    return {
      loading: true,
    }
  },
  methods: {
    wufooForm () {
      /* eslint-disable */
	  	var z1a5agy50rom721;(function (d, t) {
			var s = d.createElement(t), options = {
				'userName':'berriesandblooms',
				'formHash':'z1a5agy50rom721',
				'autoResize':true,
				'height':'557',
				'async':true,
				'host':'wufoo.com',
				'header':'show',
				'ssl':true}

			s.src = ('https:' == d.location.protocol ? 'https://' : 'http://') + 'www.wufoo.com/scripts/embed/form.js'
			s.onload = s.onreadystatechange = function () {
				var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return
				try {
					z1a5agy50rom721 = new WufooForm()
					z1a5agy50rom721.initialize(options)
					z1a5agy50rom721.display()
				} catch (e) {}
			};

			var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr)
			})(document, 'script')
  	}
  },
  mounted () {
  	this.wufooForm()
  }
}
</script>

<style lang="scss"></style>
